var _a;
import { HoldingEdelweissAssetClass } from "@frameworks/web/components/Reports/CommonComponent/constant";
import { AssetType } from "@domains/aggregates/interfaces/Reports/iPNLReport";
export var assetClassMapWithCode = (_a = {},
    _a[HoldingEdelweissAssetClass.EQUITY] = AssetType.EQ,
    _a[HoldingEdelweissAssetClass.FI] = AssetType.FixedIncome,
    _a[HoldingEdelweissAssetClass.MP] = AssetType.MP,
    _a[HoldingEdelweissAssetClass.RE] = AssetType.RealEstate,
    _a[HoldingEdelweissAssetClass.CO] = AssetType.Commodity,
    _a);
var HoldingMainDTO = /** @class */ (function () {
    function HoldingMainDTO(HoldingSummary, HoldingDetails, isOmneOnly) {
        this.HoldingSummary = HoldingSummary;
        this.HoldingDetails = HoldingDetails;
        this.isOmneOnly = isOmneOnly;
    }
    return HoldingMainDTO;
}());
export default HoldingMainDTO;
